export default "__VITE_ASSET__BsZ6E_wj__"